import Vue from 'vue';
import Router from 'vue-router';
import Tracker from '@/services/tracker';
import store from '@/store';
import Dashboard from './views/Dashboard.vue';

Vue.use(Router);

const authCampaigns = async (route, origin, next) => {
  try {
    await store.dispatch('setPageAdvertiserByCode', route.params.code);
    next();
  } catch (error) {
    window.location.href = 'https://afiliados.uol.com.br/app/campanhas';
  }
};

const authAllSitesIsNotReproved = async (route, origin, next) => {
  try {
    await store.dispatch('fetchAffiliateData');
    const { affiliateInfo } = store.getters;

    if (!affiliateInfo.urlStatus.find(status => status === 'A')) {
      throw new Error('Sites não aprovados');
    }
    next();
  } catch (error) {
    window.location.href = 'https://afiliados.uol.com.br/novo/cadastro.html';
  }
};

const router = new Router({
  mode: 'history',
  hash: false,
  base: process.env.BASE_URL,
  // eslint-disable-next-line vue/no-unused-vars
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(_to, _from, _savedPosition) {
  // eslint-disable-next-line vue/no-unused-vars
  // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, _reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 600);
    });
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: { title: 'Dashboard' },
    },
    {
      path: '/dashboard',
      redirect: () => {
        window.location.href = 'https://afiliados.uol.com.br/app';
      },
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      // route level code-splitting
      // this generates a separate chunk (report.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "report" */ './views/Report.vue'),
      meta: { title: 'Relatórios' },
      beforeEnter: authAllSitesIsNotReproved,
    },
    {
      path: '/campanhas',
      name: 'campanhas',
      component: () => import(/* webpackChunkName: "campaigns" */ './views/Campaigns.vue'),
      meta: { title: 'Campanhas' },
      beforeEnter: authAllSitesIsNotReproved,
    },
    {
      path: '/campanha/:code/novidades',
      name: 'NewsList',
      component: () => import(/* webpackChunkName: "campaigns" */ './views/NewsList.vue'),
      meta: { title: 'Novidade' },
    },
    {
      path: '/campanha/:code',
      name: 'campanha',
      component: () => import(/* webpackChunkName: "campaign" */ './views/Campaign.vue'),
      meta: { title: 'Campanha' },
      // afterEnter: authCampaigns,
    },
    {
      path: '/campanha/:code/novidade/:newsCode',
      name: 'news',
      component: () => import(/* webpackChunkName: "campaign" */ './views/News.vue'),
      meta: { title: 'Novidade' },
      beforeEnter: authCampaigns,
    },
    {
      path: '/campanha/:code/material-de-apoio',
      name: 'FileManager',
      component: () => import(/* webpackChunkName: "campaign" */ './views/FileManager.vue'),
      meta: { title: 'Material de Apoio' },
    },
    {
      path: '/campanha/:code/material-de-apoio/:folderName/:folderCode',
      name: 'FileManager',
      component: () => import(/* webpackChunkName: "campaign" */ './views/FileManager.vue'),
      meta: { title: 'Material de Apoio' },
    },
    {
      path: '/configuracao',
      name: 'settings',
      // route level code-splitting
      // this generates a separate chunk (report.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "report" */ './views/Settings.vue'),
      meta: { title: 'Configurações' },
    },
    {
      path: '/contato',
      name: 'contact',
      // route level code-splitting
      // this generates a separate chunk (report.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "report" */ './views/Contact.vue'),
      meta: { title: 'Contato' },
    },
    {
      path: '/404',
      name: 'notFound',
      // route level code-splitting
      // this generates a separate chunk (report.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "report" */ './views/NotFound.vue'),
      meta: { title: 'Página Não Encontrada' },
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      path: '/manutencao',
      name: 'maintenance',
      // route level code-splitting
      // this generates a separate chunk (report.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "report" */ './views/Maintenance.vue'),
      meta: { title: 'Manutencao' },
    },
  ],
});

router.afterEach((route) => {
  Tracker.setCategory(route.meta.title);

  if (route.params.code !== null && route.params.code !== undefined) {
    Tracker.track(`Acesso ${route.meta.title} ${route.params.code}`, 'Acesso');
  } else {
    Tracker.track(`Acesso ${route.meta.title}`, 'Acesso');
  }

  document.querySelector('title').innerHTML = `${route.meta.title} - UOL Afiliados`;

  if (route.name !== 'news') {
    store.dispatch('stopLoading');
  }
  store.dispatch('setLastAccessPage', route.path);
});

router.beforeEach(async (route, origin, next) => {
  store.dispatch('startLoading');

  await store.dispatch('getItsOnMaintenance');
  const { onMaintenance } = store.getters;

  if (onMaintenance) {
    if (route.path !== '/manutencao') {
      window.location.href = '/app/manutencao';
    }
    next();
  }

  await store.dispatch('checkAuthentication');
  const { affiliateIsAuthenticated } = store.getters;

  if (!affiliateIsAuthenticated) {
    const baseURI = 'https://conta.uol.com.br/login?t=afiliados&dest=https%3A%2F%2Fafiliados.uol.com.br%2Fapp';
    const redirPath = encodeURIComponent(route.path);
    window.location.href = baseURI.concat(redirPath);
  }

  next(affiliateIsAuthenticated);
});

export default router;
